"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.read = void 0;

var _reduce = require("../reduce/reduce");

var _is = require("../is/is");

var _pipe = require("../pipe/pipe");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _read = function _read(path, defaultValue, source) {
  var result = undefined;

  if ((0, _is.is)(source) && _typeof(source) === "object") {
    result = (0, _pipe.pipe)((0, _reduce.reduce)(function (acc, item) {
      return (0, _is.is)(acc) && _typeof(acc) === "object" ? acc[item] : undefined;
    }, source), // only return default value if it's explicitly set.
    // this way values of "null", "NaN" are not masked
    function (value) {
      return (0, _is.isNothing)(value) && (0, _is.is)(defaultValue) ? defaultValue : value;
    })(Array.isArray(path) ? path : [path]);
  }

  return (0, _is.isNothing)(result) && (0, _is.is)(defaultValue) ? defaultValue : result;
};
/**
 * Get value from obj property
 *
 * @param  {String|String[]} path         Property name or dot path of props
 * @param  {Any}             defaultValue Value to return if not found
 * @param  {Object}          source       Source object
 *
 * @return {Any}
 *
 * @name read
 * @tag Object
 * @signature (path: String|String[], source: Object|Array): mixed
 * @signature (path: String|String[], defaultValue: Any, source: Object|Array): mixed
 *
 * @example
 * read("lorem")({ lorem: "ipsum" })
 * // => "ipsum"
 *
 * read("not-exist")({ lorem: "ipsum" })
 * // => undefined
 *
 * read("not-exist-with-default", "dolor")({ lorem: "ipsum" })
 * // => "dolor"
 *
 * read(["a", "b"])({ a: { b: "c" } })
 * // => "c"
 *
 * read(["a", "test"])({ a: { b: "c" } })
 * // => undefined
 */


var read = function read() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  if (params.length <= 2) {
    return function (source) {
      return _read(params[0], params[1], source);
    };
  }

  return _read.apply(void 0, params);
};

exports.read = read;